<template>
  <b-modal
    size="lg"
    centered
    no-close-on-backdrop
    ok-title="Enviar"
    id="modal-view-credential"
    modal
    :title="$ml.get('credentials')"
  >
    <div>
      <div class="area-credential row">
        <p class="col">
          {{ $ml.get("labelCredentialForTest") }}
          <strong>{{ programName }} </strong>
          {{ $ml.get("labelCredentialForTestContinued") }}.
        </p>
      </div>
      <div v-for="(item, index) in credentialsProps" :key="index" class="mt-4">
        <div class="d-flex flex-column w-100">
          <div class="container-label">
            <div class="divisor"></div>
            <label style="font-size: 1rem; margin: 0px"
              >{{
                item.send_type === "private"
                  ? $ml.get("credentialPrivate")
                  : $ml.get("credentialPublica")
              }}
              -
              <span class="status">{{
                item.send_type === "private"
                  ? $ml.get("labelCredentialIndividual")
                  : $ml.get("labelCredentialShared")
              }}</span></label
            >
          </div>
          <div class="form-control h-100">
            <p v-html="$utils.convertMarkedOld(item.credentials)"></p>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="closeModal(cancel)"
      >
        {{ $ml.get("toClose") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "ModalViewCredential",
  props: ["credentialsProps", "programName"],

  methods: {
    closeModal(cancel) {
      this.$emit("closeModal");
      cancel();
    },
  },
};
</script>
<style scoped>
.area-credential p {
  padding: 0px;
  margin: 0px;
}
.container-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.divisor {
  width: 15px;
  height: 5px;
  background: #e10e71;
}
.status {
  padding: 0px 5px;
  border-radius: 5px;
}
</style>
